import { useEffect } from 'react';

import { ONGOING_EXPERIMENTS } from 'constants/eppo';

import { Provider } from 'services/Analytics/core';
import { getAbTestName } from 'services/Analytics/helpers';
import { useFeatureFlagWithAQA } from 'services/Eppo';

import InstallAppStepsA from './InstallAppStepsA';
import InstallAppStepsDefault from './InstallAppStepsDefault';
import { IInstallAppSteps } from './types';

const InstallAppSteps = (props: IInstallAppSteps) => {
    const { value: variant } = useFeatureFlagWithAQA<string>({
        flagKey: ONGOING_EXPERIMENTS.DownloadPageRedesign,
        defaultValue: 'Default',
        type: 'string',
    });

    useEffect(() => {
        Provider.provideData({
            abTestName: async () =>
                getAbTestName({
                    experiment: ONGOING_EXPERIMENTS.DownloadPageRedesign,
                    variantName: variant,
                }),
        });

        return () => {
            Provider.provideData({ abTestName: async () => null });
        };
    }, [variant]);

    switch (variant) {
        case 'a':
            return <InstallAppStepsA {...props} />;

        case 'default':
            return <InstallAppStepsDefault {...props} />;

        default:
            return <InstallAppStepsDefault {...props} />;
    }
};

export default InstallAppSteps;
